import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { Heading } from "@/ui/Heading";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import Image from "@/ui/Image";
import classes from "./styles.module.scss";
import G from "./assets/G.svg";
import R from "./assets/R.svg";
import E from "./assets/E.svg";
import A from "./assets/A.svg";
import T from "./assets/T.svg";
import { useIsVisible } from "@/hooks/useIsVisible";

export const CulturePageGreatSection = ({ className, variant, pathPrefix }) => {
  const [visible, visibilityRef] = useIsVisible({ partial: true, once: true });
  const locale = useLocale();

  return (
    <div ref={visibilityRef} className={clsx(className, classes.great)} data-visible={visible}>
      <Container className="mw-xxl" fluid>
        <Heading className="mb-4" variant={variant}>
          <DynamicText tag="h2" path={`${pathPrefix}.title.${locale}`} />
        </Heading>
        <Row>
          <Col xs={12} md={{ span: 10, offset: 1 }}>
            <div className={classes.great__container}>
              <div className={clsx(classes.great__gradient, "d-none d-md-flex")} />
              <div className="flex-grow-1">
                <div className={clsx(classes.great__section, "bg-quinary text-white mb-3")}>
                  <div className="bg-white p-2">
                    <G />
                  </div>
                  <dl className="p-3 pb-0 pt-md-4 ps-md-4 pe-md-0">
                    <dt>Growth</dt>
                    <dd>
                      Focusing on continuous improvement via a Growth Mindset. Constantly enhancing our emotional
                      intelligence, knowledge, skills, markets, and relationships.
                    </dd>
                  </dl>
                  <Image
                    className="d-none d-md-flex"
                    img={{
                      path: `${pathPrefix}.growth.image`,
                      src: "/assets/great/growth.png",
                    }}
                    size="260x150"
                    alt=""
                  />
                </div>
                <div className={clsx(classes.great__section, "bg-quaternary text-white mb-3")}>
                  <div className="bg-white p-2">
                    <R />
                  </div>
                  <dl className="p-3 pb-0 pt-md-4 ps-md-4 pe-md-0">
                    <dt>Rewards</dt>
                    <dd>
                      Recognising, incentivising & celebrating success and excellence. Through diverse & inclusive
                      events, prizes, holidays, and experiences; individually or together.
                    </dd>
                  </dl>
                  <Image
                    className="d-none d-md-flex"
                    img={{
                      path: `${pathPrefix}.rewards.image`,
                      src: "/assets/great/rewards.jpg",
                    }}
                    size="260x150"
                    alt=""
                  />
                </div>
                <div className={clsx(classes.great__section, "bg-senary text-white mb-3")}>
                  <div className="bg-white p-2">
                    <E />
                  </div>
                  <dl className="p-3 pb-0 pt-md-4 ps-md-4 pe-md-0">
                    <dt>Environment</dt>
                    <dd>
                      Creating a positive, supportive, balanced, and fun workplace for all. Living our values and
                      being accountable for our social, community and environmental impact.
                    </dd>
                  </dl>
                  <Image
                    className="d-none d-md-flex"
                    img={{
                      path: `${pathPrefix}.environment.image`,
                      src: "/assets/great/environment.png",
                    }}
                    size="260x150"
                    alt=""
                  />
                </div>
                <div className={clsx(classes.great__section, "bg-secondary text-white mb-3")}>
                  <div className="bg-white p-2">
                    <A />
                  </div>
                  <dl className="p-3 pb-0 pt-md-4 ps-md-4 pe-md-0">
                    <dt>Alliances</dt>
                    <dd>
                      Building inclusive partnerships through; camaraderie, networking and collaboration. With our
                      people, our candidates, and our clients.
                    </dd>
                  </dl>
                  <Image
                    className="d-none d-md-flex"
                    img={{
                      path: `${pathPrefix}.alliances.image`,
                      src: "/assets/great/alliances.png",
                    }}
                    size="260x150"
                    alt=""
                  />
                </div>
                <div className={clsx(classes.great__section, "bg-tertiary text-white")}>
                  <div className="bg-white p-2">
                    <T />
                  </div>
                  <dl className="p-3 pb-0 pt-md-4 ps-md-4 pe-md-0">
                    <dt>Talent</dt>
                    <dd>
                      Spotting, developing & nurturing talent. Providing access to award-winning L&D, mentors,
                      inspirational role models and talent mobility.
                    </dd>
                  </dl>
                  <Image
                    className="d-none d-md-flex"
                    img={{
                      path: `${pathPrefix}.talent.image`,
                      src: "/assets/great/talent.png",
                    }}
                    size="260x150"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

CulturePageGreatSection.defaultProps = {
  className: "py-4 py-md-5",
  variant: "quaternary",
  pathPrefix: "page.culture.great",
};
